import React from 'react';
import { observer, inject } from 'mobx-react';
import LineItemPickerPanel from 'components/LineItemPicker/LineItemPickerPanel';

// "Add labor" / "Add material" on an invoice (components/LineItemPicker).
// Callers pass `type`: 'Service' for labor, 'Products (Non-inventory)' for materials.
const AddProductForInvoiceModal = inject('invoiceStore')(observer(({ invoiceStore, isOpen, onClose, workDetail, type, itemType }) => {
  const kind = type === 'Service' ? 'labour' : 'material';
  return (
    <LineItemPickerPanel
      formType="Invoice"
      noun="invoice"
      record={workDetail || invoiceStore.invoice.object}
      type={type}
      itemType={itemType}
      isOpen={isOpen}
      onClose={onClose}
      blankBusy={Boolean(invoiceStore.isLoadingBlankLineItem)}
      onAddBlank={() => invoiceStore.addBlankLineItemForProduct(kind, (workDetail || invoiceStore.invoice.object).attributes.id)}
    />
  );
}));

export default AddProductForInvoiceModal;
